<app-editcompanydialog [companyId]="companyId" (savedEvent)="saveBrokerProfile($event)"></app-editcompanydialog>
